/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Circle, Polygon, Line } from 'react-native-svg';

import { IconProps } from '../lib';

function SoccerBall(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Rect width={256} height={256} fill="none" opacity={0.1} />
      <Circle
        cx={128}
        cy={128}
        r={96}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Polygon
        points="128 74.039 76.68 111.325 96.282 171.655 159.718 171.655 179.32 111.325 128 74.039"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Line
        x1={128}
        y1={32}
        x2={128}
        y2={74.0389}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Line
        x1={36.69857}
        y1={98.33437}
        x2={76.67992}
        y2={111.32512}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Line
        x1={71.57262}
        y1={205.66563}
        x2={96.28244}
        y2={171.6555}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Line
        x1={184.42738}
        y1={205.66563}
        x2={159.71756}
        y2={171.6555}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Line
        x1={219.30143}
        y1={98.33437}
        x2={179.32008}
        y2={111.32512}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
    </Svg>
  );
}

export default SoccerBall;
